import { useInstantSearch, useSearchBox, useStats } from 'react-instantsearch';
import classNames from 'classnames';

import FiltersNoResults from '@javascript/components/search_filters/units/filtersNoResults';
import InstantSearchError from '@javascript/instant_search/errors/instantSearchError';
import StockAlertLauncher from '@javascript/components/stock_alerts/stockAlertLauncher';

import { useCustomClearRefinements } from '@javascript/lib/hooks/useCustomClearRefinements';
import useInstantSearchError from '@javascript/instant_search/errors/useInstantSearchError';
import useQueryParam from '@javascript/lib/hooks/useQueryParam';

import { delimitWithCommas, pluralise } from '@lib/utils';

import Analytics from '@javascript/lib/analytics';

import { ButtonType } from '@javascript/types/ButtonType';

const InstantSearchFilterFooter = ({
  closeModal,
}: {
  closeModal: VoidFunction;
}) => {
  const { refine } = useCustomClearRefinements();
  const { clear } = useSearchBox();
  const { nbHits } = useStats();
  const { results } = useInstantSearch();
  const [stockAlertParams] = useQueryParam();

  const instantSearchError = useInstantSearchError();

  const isLoading = results?.__isArtificial;

  const showNoResultsWarning = nbHits === 0 && !isLoading;

  const buttonText = showNoResultsWarning
    ? 'Let me see all cars'
    : `Show ${delimitWithCommas(nbHits)} ${pluralise(nbHits, 'result')}`;

  const appliedFacets = {
    multiSelect: results?._state?.disjunctiveFacetsRefinements || {},
    numericSelect: results?._state?.numericRefinements || {},
    singleSelect: results?._state?.hierarchicalFacetsRefinements || {},
  };

  const onClick = () => {
    Analytics.dataPush('criteria', appliedFacets);
    if (showNoResultsWarning) {
      refine();
      clear();
    }
    closeModal();
  };

  return (
    <div className="filter__footer ch-display--flex ch-flex-direction--column ch-align-items--center">
      {instantSearchError ? (
        <div className="sm:ch-pa--2">
          <InstantSearchError {...instantSearchError} />
        </div>
      ) : (
        <>
          {showNoResultsWarning && <FiltersNoResults />}
          <button
            className={classNames(
              `filter__button ch-btn ch-btn--block ch-btn--${
                showNoResultsWarning ? ButtonType.secondary : ButtonType.success
              }`,
              isLoading && 'ch-btn--loading'
            )}
            data-gtm-track="interaction"
            data-gtm-track-action="Instant search - filters"
            data-gtm-track-label={buttonText}
            onClick={onClick}
            type="button"
          >
            {isLoading ? '' : buttonText}
          </button>
          {showNoResultsWarning && (
            <StockAlertLauncher
              additionalStyling="ch-mt--2 ch-mb--1 ch-width--12"
              stockAlertUrl={`/stock-alerts/new${stockAlertParams}`}
            />
          )}
        </>
      )}
    </div>
  );
};

export default InstantSearchFilterFooter;
